import React, { FormEvent, useEffect, useState } from 'react';

import { Button, Stack, TextField } from '@mui/material';

import { TripPlannerChatSearchParams } from '../useTripPlannerChatSearchParams';

type Props = {
  initialValues: TripPlannerChatSearchParams;
  onSearch: (values: TripPlannerChatSearchParams) => void;
};

export default function TripPlannerChatSearchForm({ initialValues, onSearch }: Props) {
  const [chatId, setChatId] = useState(initialValues.chatId ?? '');
  const [userId, setUserId] = useState(initialValues.userId ?? '');

  useEffect(() => {
    setChatId(initialValues.chatId ?? '');
    setUserId(initialValues.userId ?? '');
  }, [initialValues.chatId, initialValues.userId]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    onSearch({
      chatId,
      userId,
    });
  };

  return (
    <Stack component="form" spacing={2} mb={3} onSubmit={handleSubmit}>
      <Stack spacing={2} direction={{ xs: 'column', md: 'row' }}>
        <TextField
          label="Conversation ID"
          variant="outlined"
          value={chatId}
          fullWidth
          onChange={(event) => setChatId(event.target.value)}
        />
        <TextField
          label="User Id"
          variant="outlined"
          value={userId}
          fullWidth
          onChange={(event) => setUserId(event.target.value)}
        />
      </Stack>

      <Stack direction="row" justifyContent="space-between">
        <Button type="submit" variant="contained" color="primary">
          Search
        </Button>
      </Stack>
    </Stack>
  );
}
